module.exports = __webpack_public_path__ + "img/sdg5_jp.9cdd9d82.png";